import React from 'react';
import Section from '../components/Section';

const jobs = [
  {
    role: 'CTF Developer',
    company: 'RaZZ Security LLP',
    period: 'Sep 2025',
    points: ['Beginner-friendly CTF challenges', 'Kctf (Kubernetes) infrastructure', 'OverlayFs isolation', 'Docker & nginx deployments'],
  },
  {
    role: 'Cybersecurity Job Simulation',
    company: 'Deloitte Australia (Remote)',
    period: 'Aug 2025',
    points: ['Web activity log investigation', 'Simulated breach response', 'Client-ready recommendations'],
  },
  {
    role: 'SDE Freelancer',
    company: 'Hexmos Technologies, Bangalore',
    period: 'Feb 2022 – Aug 2025',
    points: ['50+ language frameworks, OpenAPI/Swagger', 'React + Tailwind landing page', 'Go backend (GitLab, GitHub, Bitbucket)', 'Cryptojacking hardening'],
  },
];

export default function Experience() {
  return (
    <Section id="experience" title="Experience">
      <div className="experience-grid">
        {jobs.map((job, i) => (
          <div key={i} className="experience-card">
            <div className="experience-header">
              <span className="experience-role">{job.role}</span>
              <span className="experience-period">{job.period}</span>
            </div>
            <div className="experience-company">{job.company}</div>
            <ul className="experience-points">
              {job.points.map((p, j) => (
                <li key={j}>{p}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </Section>
  );
}
